import { c as _c } from "react/compiler-runtime";
import { Box, type BoxProps } from '@mui/material';
import type { PropsWithChildren } from 'react';
type Props = BoxProps & {
  background?: string;
  backgroundColor?: string;
  backgroundImage?: string;
  backgroundSize?: string;
};
export function FullBleedBox(t0) {
  const $ = _c(22);
  let background;
  let backgroundColor;
  let backgroundImage;
  let backgroundSize;
  let children;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      background,
      backgroundColor,
      backgroundImage,
      backgroundSize,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = background;
    $[2] = backgroundColor;
    $[3] = backgroundImage;
    $[4] = backgroundSize;
    $[5] = children;
    $[6] = props;
  } else {
    background = $[1];
    backgroundColor = $[2];
    backgroundImage = $[3];
    backgroundSize = $[4];
    children = $[5];
    props = $[6];
  }
  let rest;
  let sx;
  if ($[7] !== props) {
    ({
      sx,
      ...rest
    } = props);
    $[7] = props;
    $[8] = rest;
    $[9] = sx;
  } else {
    rest = $[8];
    sx = $[9];
  }
  let t1;
  if ($[10] !== background || $[11] !== backgroundColor || $[12] !== backgroundImage || $[13] !== backgroundSize) {
    t1 = {
      content: "\"\"",
      position: "absolute",
      zIndex: -1,
      top: 0,
      left: "50%",
      transform: "translateX(-50%)",
      width: "100vw",
      height: "100%",
      background,
      backgroundColor,
      backgroundImage,
      backgroundSize
    };
    $[10] = background;
    $[11] = backgroundColor;
    $[12] = backgroundImage;
    $[13] = backgroundSize;
    $[14] = t1;
  } else {
    t1 = $[14];
  }
  let t2;
  if ($[15] !== sx || $[16] !== t1) {
    t2 = {
      position: "relative",
      "&:before": t1,
      ...sx
    };
    $[15] = sx;
    $[16] = t1;
    $[17] = t2;
  } else {
    t2 = $[17];
  }
  let t3;
  if ($[18] !== children || $[19] !== rest || $[20] !== t2) {
    t3 = <Box sx={t2} {...rest}>{children}</Box>;
    $[18] = children;
    $[19] = rest;
    $[20] = t2;
    $[21] = t3;
  } else {
    t3 = $[21];
  }
  return t3;
}